export default __webpack_public_path__ + "static/media/sticker-4.4fd12b8d.png";